import { ActorName } from '../../constants';
import { ActorsPool } from '../ActorManager';
import { Principal } from '@dfinity/principal';
export class IAMRepository {
    /**
     * Retrieves username by principal
     * @param {string} principal
     * @return {Promise<string | undefined>>}
     */
    async getUsernameByPrincipal(principal) {
        const actor = ActorsPool.getActor(ActorName.IAM);
        const usernameResponse = await actor.lookupUsername(Principal.fromText(principal));
        return usernameResponse[0];
    }
    /**
     * Creates a new user profile
     * @param {IAMUserProfilePayload} values
     */
    async register(values) {
        const actor = ActorsPool.getActor(ActorName.IAM);
        return actor.register(values);
    }
    /**
     * Retrieves the user profile
     * @return {Promise<Account | undefined>}
     */
    async getProfile() {
        const actor = ActorsPool.getActor(ActorName.IAM);
        const profileResponse = await actor.getProfile();
        return IAMRepository.profileToAccount(profileResponse[0]);
    }
    /**
     * Updates user profile
     * @param {IAMUserProfilePayload} values
     * @return {Promise<Account | undefined>}
     */
    async updateProfile(values) {
        const actor = ActorsPool.getActor(ActorName.IAM);
        const { email, username } = values;
        const profileResponse = await actor.updateProfile({
            email: email ? [email] : [],
            username: username ? [username] : [],
        });
        return IAMRepository.profileToAccount(profileResponse[0]);
    }
    /**
     * Converts a Profile to a serializable object
     * @param profile
     * @return {Account | undefined}
     */
    static profileToAccount(profile) {
        if (!profile) {
            return;
        }
        const { id, username, email } = profile;
        return {
            id: id.toText(),
            username,
            email,
        };
    }
    /**
     * Removes user profile
     */
    async closeAccount() {
        const actor = ActorsPool.getActor(ActorName.IAM);
        return actor.deleteProfile();
    }
}
//# sourceMappingURL=IAMRepository.js.map